module.exports = __webpack_public_path__ + "static/media/sporttag.dd25e7ce.png";